<template>
  <div class="card">
    <div class="table-responsive" style="min-height: 400px;">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Start Date</th>
          <th>End Date</th>
          <th class="text-center">Total Earning</th>
          <th class="text-center">Total Deduction</th>
          <th class="text-center">Total Net Payable</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in payrollStatementList" :key="i">
          <td>{{ item.payroll_start_date }}</td>
          <td>{{ item.payroll_end_date }}</td>
          <td class="text-center">{{ item.total_earning }}</td>
          <td class="text-center">{{ item.total_deduction }}</td>
          <td class="text-center">{{ item.total_net_payable }}</td>
          <td class="text-center">
            <div class="d-flex">
            <button class="btn btn-primary btn-sm me-1"
                    @click="goToShow(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>

              <button title="Payment Advice" class="btn btn-success btn-sm me-1"
                      @click="payrollAdviceSummary(item)"
                      style="cursor: pointer"
              >
                <i class="fas fa-hand-holding-dollar"></i>
              </button>

              <button title="Payslip Issue" class="btn btn-secondary btn-sm me-1"
                      @click="payslipIssue(item)"
                      style="cursor: pointer"
              >
                <i class="fas fa-receipt"></i>
              </button>

            <div class="dropdown">
              <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="goToPrint(item)">
                    <i class="fas fa-print me-2"></i> Print
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="exportTable(item)">
                    <i class="fas fa-file-export me-2"></i> Export
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="goToExportJournal(item)">
                    <i class="fas fa-book me-2"></i> Export Journal
                  </a>
                </li>
              </ul>
            </div>
            </div>

          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="payrollStatementList.length < 0" class="text-center mt-5">No data</p>
    </div>

  </div>
  <div class="px-2 position-absolute bottom-0 mt-5">
    <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
  </div>

  <PayrollAdviceSummaryModal
      v-if="store.state.isModalOpenTwo"
      :payrollAdviceSummaryData="payrollAdviceSummaryData"
  />

  <PaySlipIssueModal
      v-if="store.state.isModalOpenThree"
      :payrollStatementData="payrollStatementData"
  />

</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import {computed, inject, onMounted, reactive, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import payrollStatementPdf from '@/services/utils/pdf/payrollStatementPdf';
import handleCompany from "@/services/modules/company";
import PaySlipIssueModal from "@/components/molecule/company/hrm-payroll/payroll/PaySlipIssueModal";
import PayrollAdviceSummaryModal from "@/components/molecule/company/hrm-payroll/payroll-advice/PayrollAdviceSummaryModal";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const saveButtonLoader = ref(false)
const params = ref({
  offset: 20,
});
const payrollStatementList = ref([])
const grossComponentPayHead = ref([]);
const otherEarningPayHead = ref([]);
const deductionPayHeadPayHead = ref([]);
const payrollData = ref([]);
const summaryData = ref([]);
const payrollAdviceSummaryData = ref([]);
const payrollStatementData = ref([]);
let companyInfo = reactive({})
const token = computed(() => localStorage.getItem('token'));

const {
  fetchPayrollStatementData,
  showPayrollStatementData,
  getPayrollAdviceSummary
} = handleHrPayroll()
const { exportToPDF } = payrollStatementPdf();
const { fetchCompanyInfo } = handleCompany();

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPayrollStatementList();
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const exportTable = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  let url = `${process.env.VUE_APP_BASE_URL}/api/hr-payroll/payroll-statement/${item.id}${query}&_token=${token.value}&is_export=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
};

const goToExportJournal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  let url = `${process.env.VUE_APP_BASE_URL}/api/hr-payroll/payroll-journals/${item.id}${query}&_token=${token.value}&is_export=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
};

async function payslipIssue(item){
  let query = `?company_id=${route.params.companyId}`;
  await showPayrollStatementData(item.id, query).then((res) => {
    if (!res.status) {
      return
    }
    payrollStatementData.value = res.data.payroll_statement;
  }).then(() => {
    store.state.isModalOpenThree = true
  });
}

async function goToPrint(item) {
  payrollData.value = []
  otherEarningPayHead.value = []
  grossComponentPayHead.value = []
  deductionPayHeadPayHead.value = []
  summaryData.value = []
  payrollStatementData.value = []

  let query = `?company_id=${route.params.companyId}`;
  await showPayrollStatementData(item.id, query).then((res) => {
    if (!res.status) {
         return
    }
    grossComponentPayHead.value = res.data.components.gross;
    otherEarningPayHead.value = res.data.components.earning;
    deductionPayHeadPayHead.value = res.data.components.deduction;
    summaryData.value = res.data.summary;
    payrollData.value = res.data.data;
    payrollStatementData.value = res.data.payroll_statement;
  }).then(() => {
    exportToPDF(
        companyInfo, grossComponentPayHead.value, otherEarningPayHead.value,
        deductionPayHeadPayHead.value, payrollData.value, summaryData.value, payrollStatementData.value
    )
  }).catch((err) => {
    console.log("Something went wrong");
  });
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const payrollAdviceSummary = async (item) => {
  let query = `?company_id=${route.params.companyId}`;

  await getPayrollAdviceSummary(item.id, query).then((res) => {
    if (!res.status) {
      showError(res.message)
      return
    }

    payrollAdviceSummaryData.value = res.data
  })

  store.state.isModalOpenTwo = true
}

const goToShow = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
    payrollStatementId:item.id
  }

  let query = route.query;

  router.push({
    name:  'payroll-statement',
    params: param,
    query: query
  })
}

const getPayrollStatementList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset

  loading.value = true
  payrollStatementList.value = []

  await fetchPayrollStatementData(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    payrollStatementList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  Promise.all([
    setCompanyInfo(),
    getPayrollStatementList()
  ])
})

</script>
